import assigWith from "lodash/assignWith";
import classNames from "classnames";
import React from "react";
function customizer(objValue, srcValue) {
  return srcValue === undefined ? objValue : srcValue;
}
/**
 * @description 用于合并props和defaultProps
 * @param items 参数为任意值
 * @returns 返回合并后的props
 */
export function mergeProps() {
  var ret = Object.assign({}, arguments.length <= 0 ? undefined : arguments[0]);
  for (var i = 1; i < arguments.length; i++) {
    ret = assigWith(ret, i < 0 || arguments.length <= i ? undefined : arguments[i], customizer);
  }
  return ret;
}
export function withNativeProps(props, element) {
  var p = Object.assign({}, element.props);
  if (props.className) {
    p.className = classNames(element.props.className, props.className);
  }
  if (props.style) {
    p.style = Object.assign(Object.assign({}, p.style), props.style);
  }
  if (props.tabIndex !== undefined) {
    p.tabIndex = props.tabIndex;
  }
  for (var key in props) {
    if (!props.hasOwnProperty(key)) continue;
    if (key.startsWith("data-") || key.startsWith("aria-")) {
      p[key] = props[key];
    }
  }
  return /*#__PURE__*/React.cloneElement(element, p);
}